import { twMerge } from 'tailwind-merge'
import { useCategories } from '../api/getCategories'
import { Projects } from '../components/Projects'
import { useCurrentCategory } from '../store/currentCategory'

export const Portfolio = () => {
  const categories = useCategories()
  const currentCategory = useCurrentCategory()
  if (categories.isLoading) {
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <div className="size-[1em] animate-loader  rounded-[50%] text-[45px] text-[#D4AF37]"></div>
      </div>
    )
  }
  if (!categories.data) return null

  return (
    <>
      <div className={`mx-auto flex flex-col gap-y-[16px]`}>
        <div className="flex justify-center gap-x-[]">
          {categories.data?.map((category, index) => (
            <span
              key={index}
              onClick={() => currentCategory.setCategory(category._id)}
              className={twMerge(
                ' border-r cursor-pointer border-[#000000] px-[10px] md:px-[25px] md:py-[5px] lg:px-[40px] md:text-[14px] lg:text-[16px] md:leading-[16.8px] lg:leading-[19.2px] text-[#000000] lg:py-[10px] py-[5px] font-nunito text-[12px] leading-[14.4px] [font-weight:500] ',
                index === categories.data.length - 1 ? 'border-r-0' : '',
                currentCategory.category === category._id
                  ? 'text-[#D4AF37] font-bold'
                  : ''
              )}
            >
              {category.name}
            </span>
          ))}
        </div>
        <Projects id={currentCategory.category} />
      </div>
    </>
  )
}
